// extracted by mini-css-extract-plugin
module.exports = {"NavItem":"NavItem_NavItem__23ull","active":"NavItem_active__Pn-cv"};